import template from './adpNotificationsList.html';
import controller from './adpNotificationsList.controller';
import './adpNotificationsList.less';

let adpNotificationsListComponent = {
  restrict: 'E',
  bindings: {
    listItemHeading: '<',
    title:'<',
    date:'<',
    hour: '<',
    count: '<',
    hasErrors: '<',
    id: '<',
    ngModel: '<',
  },
  template,
  controller
};

export default adpNotificationsListComponent;



// WEBPACK FOOTER //
// ./src/app/components/adpNotificationsList/adpNotificationsList.component.js